<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nome</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cpf"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CPF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnh"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNH</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="categoria"
              :options="this.$parent.optionsCategoria"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Categoria"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_vinculo"
              :options="this.$parent.optionsTpVinculo"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Vínculo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_situacao"
              :options="this.$parent.optionsTpSituacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Situação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Inicial"
              v-model="dt_expiracao_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Final"
              v-model="dt_expiracao_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from 'moment'
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      nome: "",
      cpf: "",
      cnh: "",
      categoria: "",
      dt_expiracao_ini: "",
      dt_expiracao_fim: "",
      dt_expiracao_ini_label: "",
      dt_expiracao_fim_label: "",
      tp_vinculo: "",
      tp_situacao: "",
      status: "",
      data_filter: [],
    };
  },
  mounted() {},
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_expiracao_ini_label = this.dt_expiracao_ini;
      this.dt_expiracao_fim_label = this.dt_expiracao_fim;
      this.dt_expiracao_ini = this.formatDateSubmit(this.dt_expiracao_ini);
      this.dt_expiracao_fim = this.formatDateSubmit(this.dt_expiracao_fim);
      this.data_filter = {
        nome: this.nome,
        cpf: this.cpf,
        tp_situacao: this.tp_situacao,
        cnh: this.cnh,
        categoria: this.categoria,
        dt_expiracao_ini: this.dt_expiracao_ini,
        dt_expiracao_fim: this.dt_expiracao_fim,
        tp_vinculo: this.tp_vinculo,
        status: this.status,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_expiracao_ini = this.dt_expiracao_ini_label;
      this.dt_expiracao_fim = this.dt_expiracao_fim_label;
    },
    resetFilter() {
      this.nome = ""; // clear the text in text input
      this.cpf = "";
      this.cnh = "";
      this.categoria = "";
      this.dt_expiracao_ini = "";
      this.dt_expiracao_fim = "";
      this.tp_vinculo = "";
      this.tp_situacao = "";
      this.status = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
